module.exports = __webpack_public_path__ + "img/message-icon.04d2342f.svg";